import TopicDetail from './TopicDetail'

export default TopicDetail
